import React, { useState } from "react";
import { deactivateCallerId } from "../../functions/office/editOfficeNumber";
import { useNavigate } from "react-router";

export const DeactivateCallerIdModal = ({
  officeId,
  setDeactivateCallerIdModal,
}) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(
    "Are you sure you want to deactivate verified caller ID for this office?"
  );
  const [showConfirmBtn, setShowConfirmBtn] = useState(true);

  const handleClose = () => {
    // navigate(`/viewUserInfo`);
    setDeactivateCallerIdModal(false);
  };

  const confirmed = async () => {
    console.log("Here is office Id", officeId);

    const result = await deactivateCallerId(officeId);

    if (result.result !== 0) {
      setMessage("Error: Failed to deactivate Caller ID for this office.");
      setShowConfirmBtn(false);
    } else {
      setMessage(`Success: Caller ID deactivated.`);
      setShowConfirmBtn(false);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={() => handleClose()} />
      <div className="modal-wrapper">
        <div className="modal">
          <div className="modal-header">
            <h5 className="modal-heading">Confirmation</h5>
          </div>
          <div className="modal-message">{message}</div>
          <div className="modal-btns">
            {showConfirmBtn && (
              <button className="modal-confirm-btn" onClick={() => confirmed()}>
                Confirm
              </button>
            )}
            <button className="modal-cancel-btn" onClick={() => handleClose()}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeactivateCallerIdModal;
